// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as JsxPPXReactSupportC from "rescript/lib/es6/jsxPPXReactSupportC.js";
import * as PlayIcon$LiteracyplanetTupperware from "../v2/PlayIcon.res.mjs";
import * as TickIcon$LiteracyplanetTupperware from "../v2/TickIcon.res.mjs";
import * as CrossIcon$LiteracyplanetTupperware from "../v2/CrossIcon.res.mjs";
import * as V2ExerciseContext$LiteracyplanetTupperware from "../v2/V2ExerciseContext.res.mjs";

function PilotEndScreenContainer$EndScreenLink(props) {
  var onChangeQuestion = props.onChangeQuestion;
  var index = props.index;
  var marked = props.marked;
  var correct = props.correct;
  return React.createElement("div", {
              className: "grid grid-cols-12 border border-[#0c9ce5] rounded-full p-1 cursor-pointer",
              onClick: (function (param) {
                  Curry._1(onChangeQuestion, index);
                })
            }, React.createElement("div", {
                  className: "col-span-1 flex items-center justify-center"
                }, String(index + 1 | 0)), React.createElement("div", {
                  className: "col-span-5 flex items-center justify-center gap-2"
                }, marked ? (
                    correct ? React.createElement(TickIcon$LiteracyplanetTupperware.make, {
                            className: "w-5 h-5 fill-lpTick"
                          }) : React.createElement(CrossIcon$LiteracyplanetTupperware.make, {
                            className: "w-5 h-5 fill-lpCross"
                          })
                  ) : null, marked ? (
                    props.attempted ? "Attempted" : "Not Attempted"
                  ) : "---"), React.createElement("div", {
                  className: "col-span-4 flex items-center justify-center"
                }, correct ? "Correct" : "Incorrect"), React.createElement(PlayIcon$LiteracyplanetTupperware.make, {
                  className: "col-span-2 w-10 h-10 justify-self-right flex items-center justify-center",
                  playClassName: "fill-white",
                  backgroundClassName: "fill-[#1ECC11] hover:fill-[#00802a]"
                }));
}

var EndScreenLink = {
  make: PilotEndScreenContainer$EndScreenLink
};

function PilotEndScreenContainer$TableRow(props) {
  var index = props.index;
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  var onChangeQuestion = match.onChangeQuestion;
  var match$1 = Curry._1(match.getStep, index);
  if (typeof match$1 !== "object") {
    return React.createElement(PilotEndScreenContainer$EndScreenLink, {
                attempted: false,
                correct: false,
                marked: false,
                index: index,
                onChangeQuestion: onChangeQuestion
              });
  }
  if (match$1.TAG === "Attempted") {
    return React.createElement(PilotEndScreenContainer$EndScreenLink, {
                attempted: true,
                correct: false,
                marked: false,
                index: index,
                onChangeQuestion: onChangeQuestion
              });
  }
  var match$2 = match$1._0;
  if (typeof match$2 !== "object") {
    throw {
          RE_EXN_ID: "Match_failure",
          _1: [
            "PilotEndScreenContainer.res",
            34,
            4
          ],
          Error: new Error()
        };
  }
  var questionCorrect = match$2._0.questionCorrect;
  var tmp = match$1._1;
  if (typeof tmp !== "object") {
    if (!questionCorrect) {
      return React.createElement(PilotEndScreenContainer$EndScreenLink, {
                  attempted: true,
                  correct: false,
                  marked: true,
                  index: index,
                  onChangeQuestion: onChangeQuestion
                });
    }
    if (questionCorrect) {
      return React.createElement(PilotEndScreenContainer$EndScreenLink, {
                  attempted: false,
                  correct: true,
                  marked: true,
                  index: index,
                  onChangeQuestion: onChangeQuestion
                });
    }
    
  }
  if (questionCorrect) {
    return React.createElement(PilotEndScreenContainer$EndScreenLink, {
                attempted: true,
                correct: true,
                marked: true,
                index: index,
                onChangeQuestion: onChangeQuestion
              });
  }
  if (!questionCorrect) {
    return React.createElement(PilotEndScreenContainer$EndScreenLink, {
                attempted: true,
                correct: false,
                marked: true,
                index: index,
                onChangeQuestion: onChangeQuestion
              });
  }
  throw {
        RE_EXN_ID: "Match_failure",
        _1: [
          "PilotEndScreenContainer.res",
          34,
          4
        ],
        Error: new Error()
      };
}

var TableRow = {
  make: PilotEndScreenContainer$TableRow
};

function PilotEndScreenContainer(props) {
  var match = V2ExerciseContext$LiteracyplanetTupperware.use();
  return React.createElement("div", {
              className: "grid grid-cols-12"
            }, React.createElement("div", {
                  className: "col-start-4 col-span-6 space-y-2"
                }, React.createElement("div", {
                      className: "grid grid-cols-12 text-sm"
                    }, React.createElement("div", {
                          className: "col-start-2 col-span-5 flex items-center justify-center"
                        }, "YOUR RESPONSE"), React.createElement("div", {
                          className: "col-span-4 flex items-center justify-center"
                        }, "ANSWER")), Belt_Array.mapWithIndex(Belt_Array.make(match.questionCount, 1), (function (index, param) {
                        return JsxPPXReactSupportC.createElementWithKey("endscreen-" + String(index), PilotEndScreenContainer$TableRow, {
                                    index: index
                                  });
                      }))));
}

var make = PilotEndScreenContainer;

export {
  EndScreenLink ,
  TableRow ,
  make ,
}
/* react Not a pure module */
